import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/DescriptionList/sgds-description-list";
import { register } from "../../utils/ce-registry";

register("sgds-description-list", Component);

export default createComponent({
  react: React,
  tagName: "sgds-description-list",
  elementClass: Component,
  events: {}
});
